import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { ShowSnackbar, SimpleSnackbar, SnackbarConfiguration } from '@celum/common-components';
import { UUIDGenerator } from '@celum/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private store = inject(Store);

  public info(message: string, titleParams?: object): void {
    this.store.dispatch(new ShowSnackbar(UUIDGenerator.generateId(), SimpleSnackbar, SnackbarConfiguration.success(message, titleParams)));
  }

  public error(message: string, titleParams?: object): void {
    this.store.dispatch(new ShowSnackbar(UUIDGenerator.generateId(), SimpleSnackbar, SnackbarConfiguration.error(message, { titleParams })));
  }
}
